import { Grid } from '@material-ui/core';
import NumberFormat from 'react-number-format';
import styled from 'styled-components';
import { Vehicle } from 'types/vehicle';
import { MakeAlternativeOfferModal } from '../../../../Seller/VehicleSales/components/MakeAlternativeOfferModal';
import { useDispatch, useSelector } from 'react-redux';
import { modalsToggle } from '../../../../../actions';
import { ActionButton } from '../../../../../components/ActionButton';

const StyledBold = styled.span`
  font-weight: 500;
  font-size: 16px;
`;

export const SellerAlternativeOfferBlock = ({ vehicle }: { vehicle: Vehicle }) => {
  const alternativeOffer = vehicle.active_alternative_offer;
  const dispatch = useDispatch();
  const user = useSelector((state: any) => state.user.user);

  const counterDisabled = vehicle.in_battle && user.role !== 'admin';

  const openModal = () => {
    if (counterDisabled) {
      return;
    }

    dispatch(modalsToggle(`makeAlternativeOffer-${vehicle.id}`));
  };
  return (
    <>
      <Grid container alignItems="center" justify="space-between">
        <Grid item xs={12} sm={8}>
          <StyledBold>
            <span>Seller Offer: </span>
            {alternativeOffer ? (
              <NumberFormat value={alternativeOffer.amount} displayType="text" thousandSeparator prefix="$" />
            ) : (
              'N/A'
            )}
          </StyledBold>
        </Grid>

        <Grid item xs={12} sm={4}>
          <ActionButton colorVariant="counter" fullWidth disabled={counterDisabled} onClick={openModal}>
            COUNTER
          </ActionButton>
        </Grid>
      </Grid>
      <MakeAlternativeOfferModal currentVehicle={vehicle} />
    </>
  );
};
